export const categoryList = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line' },
  { slug: 'hanman', name: '韩漫', icon: 'ri-global-line' },
  { slug: 'guoman', name: '国漫', icon: 'ri-flag-2-line' },
  { slug: 'shaonian', name: '少年热血', icon: 'ri-fire-line' },
  { slug: 'shaonv', name: '少女恋爱', icon: 'ri-heart-line' },
  { slug: 'xuanhuan', name: '玄幻修仙', icon: 'ri-moon-line' },
  { slug: 'dushi', name: '都市日常', icon: 'ri-building-line' },
  { slug: 'xuanyi', name: '悬疑推理', icon: 'ri-search-eye-line' },
  { slug: 'gaoxiao', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'kehuan', name: '科幻未来', icon: 'ri-rocket-line' },
  { slug: 'maoxian', name: '冒险格斗', icon: 'ri-sword-line' },
];

export const mangaList = [
  {
    id: 1,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: 'riman',
    subCategory: 'shaonian',
    tags: ['日漫', '少年热血', '冒险'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20young%20warrior%20with%20a%20katana%20sword%2C%20wearing%20a%20traditional%20Japanese%20uniform%2C%20dramatic%20lighting%20with%20fire%20and%20water%20elements%2C%20clean%20minimal%20background%2C%20anime%20art%20style%2C%20bold%20composition%2C%20warm%20coral%20and%20dark%20tones%2C%20high%20contrast%2C%20dynamic%20pose&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    description: '时值日本大正时期。传说太阳下山后，有恶鬼出没吃人。亦有猎鬼人斩杀恶鬼、保护人们。卖炭少年炭治郎，他那平凡而幸福的日常生活，在家人遭到恶鬼袭击的那一天发生了剧变。',
    chapters: 205,
    status: '已完结',
    rating: 9.6,
    views: 12800000,
    updateTime: '2024-12-15',
    featured: true,
    latestChapter: '第205话 生命之光辉',
  },
  {
    id: 2,
    title: '间谍过家家',
    author: '远藤达哉',
    category: 'riman',
    subCategory: 'gaoxiao',
    tags: ['日漫', '搞笑日常', '温馨'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20family%20of%20three%20in%20formal%20attire%2C%20a%20man%20in%20suit%2C%20a%20woman%20with%20red%20hair%2C%20and%20a%20little%20girl%20with%20pink%20hair%2C%20playful%20and%20elegant%20composition%2C%20clean%20minimal%20background%2C%20anime%20art%20style%2C%20warm%20coral%20and%20cream%20tones&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    description: '为了潜入名校，西国能力最强的间谍「黄昏」被下令组建家庭。但是，他的「女儿」居然是能够读取他人内心的超能力者！「妻子」是暗杀者？互相隐藏了真实身份的新家庭，面临考验与世界危机！',
    chapters: 98,
    status: '连载中',
    rating: 9.4,
    views: 9600000,
    updateTime: '2025-01-20',
    featured: true,
    latestChapter: '第98话 家庭的形状',
  },
  {
    id: 3,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: 'hanman',
    subCategory: 'maoxian',
    tags: ['韩漫', '冒险格斗', '爽文'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20cool%20male%20hunter%20with%20dark%20hair%20and%20glowing%20blue%20eyes%2C%20wearing%20black%20armor%2C%20holding%20a%20dagger%2C%20surrounded%20by%20shadow%20soldiers%2C%20clean%20minimal%20background%2C%20Korean%20webtoon%20art%20style%2C%20cool%20dark%20tones%2C%20dramatic%20lighting&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    description: '10年前，世界与其他次元连接的「门」被打开，被称为「猎人」的觉醒者们出现。被称为「人类最弱兵器」的E级猎人成振宇，在一次双重地下城任务中濒临死亡，却意外获得了「系统」的能力，成为唯一可以「升级」的猎人。',
    chapters: 179,
    status: '已完结',
    rating: 9.7,
    views: 15200000,
    updateTime: '2024-11-30',
    featured: true,
    latestChapter: '第179话 最终话',
  },
  {
    id: 4,
    title: '斗罗大陆',
    author: '唐家三少 / 穆逢春',
    category: 'guoman',
    subCategory: 'xuanhuan',
    tags: ['国漫', '玄幻修仙', '热血'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20handsome%20young%20martial%20artist%20with%20blue%20hair%2C%20wearing%20elegant%20traditional%20Chinese%20robes%2C%20surrounded%20by%20glowing%20spirit%20rings%2C%20mystical%20atmosphere%2C%20clean%20minimal%20background%2C%20Chinese%20manhua%20art%20style%2C%20ethereal%20warm%20tones&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。这里没有魔法，没有斗气，没有武术，却有神奇的武魂。每个人在六岁时都会觉醒自己的武魂。',
    chapters: 352,
    status: '连载中',
    rating: 9.3,
    views: 18500000,
    updateTime: '2025-02-01',
    featured: true,
    latestChapter: '第352话 海神之光',
  },
  {
    id: 5,
    title: '葬送的芙莉莲',
    author: '山田钟人 / 阿部司',
    category: 'riman',
    subCategory: 'maoxian',
    tags: ['日漫', '冒险', '治愈'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20an%20elf%20girl%20with%20long%20silver%20hair%2C%20wearing%20a%20white%20robe%2C%20holding%20a%20staff%2C%20standing%20in%20a%20field%20of%20flowers%2C%20gentle%20and%20melancholic%20atmosphere%2C%20clean%20minimal%20background%2C%20anime%20art%20style%2C%20soft%20warm%20tones&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    description: '打倒魔王的勇者一行人「之后」的故事。身为精灵的魔法使芙莉莲，与勇者辛美尔等人历经十年冒险打倒魔王，为世界带来和平。由于她身为精灵，寿命远超常人，对于勇者辛美尔的逝世，她再次感受到了「别离」的重量。',
    chapters: 140,
    status: '连载中',
    rating: 9.8,
    views: 8600000,
    updateTime: '2025-01-25',
    featured: false,
    latestChapter: '第140话 黄金乡',
  },
  {
    id: 6,
    title: '全职猎人',
    author: '富坚义博',
    category: 'riman',
    subCategory: 'shaonian',
    tags: ['日漫', '少年热血', '冒险'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20young%20boy%20with%20spiky%20black%20hair%20and%20green%20outfit%2C%20holding%20a%20fishing%20rod%2C%20determined%20expression%2C%20clean%20minimal%20background%2C%20classic%20anime%20art%20style%2C%20vibrant%20warm%20coral%20and%20green%20tones&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    description: '主人公杰·富力士从小在鲸鱼岛长大，与米特阿姨和阿婆相依为命。性格开朗的他，有着能与动物沟通的灵性。因为无父无母，刚将米特阿姨当作自己的生母般爱护。直到9岁那年，刚在森林里被一位青年男子搭救——此人正是刚的父亲——金的徒弟。',
    chapters: 400,
    status: '连载中',
    rating: 9.5,
    views: 11200000,
    updateTime: '2025-01-10',
    featured: false,
    latestChapter: '第400话 黑暗大陆篇',
  },
  {
    id: 7,
    title: '女神降临',
    author: 'Yaongyi',
    category: 'hanman',
    subCategory: 'shaonv',
    tags: ['韩漫', '少女恋爱', '化妆'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20brown%20hair%2C%20wearing%20elegant%20makeup%2C%20confident%20expression%2C%20soft%20pastel%20background%2C%20Korean%20webtoon%20art%20style%2C%20romantic%20warm%20pink%20and%20coral%20tones&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    description: '因为外貌在学校被霸凌的任朱静，透过化妆技术摇身一变化为校园女神。没想到学校的两位高人气男神——高冷校草李修豪和阳光暖男韩书竣，竟然都对她产生了兴趣，三人之间展开了令人心动的三角恋情。',
    chapters: 230,
    status: '已完结',
    rating: 9.1,
    views: 10500000,
    updateTime: '2024-10-20',
    featured: false,
    latestChapter: '第230话 最终话 女神',
  },
  {
    id: 8,
    title: '大王饶命',
    author: '会说话的肘子 / 小刑天',
    category: 'guoman',
    subCategory: 'xuanhuan',
    tags: ['国漫', '玄幻修仙', '搞笑'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20mischievous%20young%20man%20in%20modern%20clothing%20with%20traditional%20elements%2C%20smirking%20expression%2C%20surrounded%20by%20spiritual%20energy%2C%20clean%20minimal%20background%2C%20Chinese%20manhua%20art%20style%2C%20warm%20amber%20and%20coral%20tones&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    description: '灵气复苏的时代，吕树因为意外觉醒了能力，可以看见别人的负面情绪值，并靠收集这些情绪值来变强。从此，他开始了一段气死人不偿命的变强之路。别人修仙靠灵气，吕树修仙靠气人！',
    chapters: 280,
    status: '连载中',
    rating: 9.2,
    views: 9800000,
    updateTime: '2025-01-28',
    featured: false,
    latestChapter: '第280话 天罗地网',
  },
  {
    id: 9,
    title: '电锯人',
    author: '藤本树',
    category: 'riman',
    subCategory: 'shaonian',
    tags: ['日漫', '少年热血', '黑暗'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20blonde%20young%20man%20with%20sharp%20teeth%2C%20chainsaw%20arms%2C%20wearing%20a%20white%20shirt%20and%20tie%2C%20chaotic%20urban%20background%2C%20clean%20minimal%20composition%2C%20anime%20art%20style%2C%20high%20contrast%20dark%20and%20coral%20tones&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    description: '负债累累的贫穷少年淀治，与恶魔波奇塔一起做着恶魔猎人工作勉强维生。某天他被债主黑帮杀害，濒死之际波奇塔与他签订契约，淀治的心脏与波奇塔融合，成为了「电锯人」，并被公安对魔特异4课收编。',
    chapters: 180,
    status: '连载中',
    rating: 9.3,
    views: 9200000,
    updateTime: '2025-02-03',
    featured: false,
    latestChapter: '第180话 普通生活',
  },
  {
    id: 10,
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    category: 'hanman',
    subCategory: 'shaonv',
    tags: ['韩漫', '少女恋爱', '穿越'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20beautiful%20princess%20with%20blonde%20hair%20and%20blue%20eyes%2C%20wearing%20a%20gorgeous%20pink%20gown%2C%20holding%20a%20rose%2C%20royal%20palace%20background%2C%20clean%20minimal%20composition%2C%20Korean%20webtoon%20art%20style%2C%20romantic%20warm%20pink%20and%20gold%20tones&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    description: '某天醒来，我变成了小说中的悲剧公主阿希娅。按照原作，我将在18岁生日那天被自己的亲生父亲——皇帝克劳德处死。为了活下去，我必须想尽一切办法讨好这个冷酷无情的父亲！',
    chapters: 125,
    status: '已完结',
    rating: 9.4,
    views: 7800000,
    updateTime: '2024-09-15',
    featured: false,
    latestChapter: '第125话 永远的幸福',
  },
  {
    id: 11,
    title: '完美世界',
    author: '辰东',
    category: 'guoman',
    subCategory: 'xuanhuan',
    tags: ['国漫', '玄幻修仙', '热血'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20powerful%20young%20cultivator%20with%20flowing%20black%20hair%2C%20wearing%20ancient%20Chinese%20battle%20armor%2C%20standing%20on%20a%20mountain%20peak%2C%20dramatic%20sky%2C%20clean%20minimal%20background%2C%20Chinese%20manhua%20art%20style%2C%20epic%20warm%20golden%20and%20coral%20tones&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。少年石昊自大荒中走出，一切从这里开始。',
    chapters: 310,
    status: '连载中',
    rating: 9.4,
    views: 13500000,
    updateTime: '2025-01-30',
    featured: true,
    latestChapter: '第310话 太古盟约',
  },
  {
    id: 12,
    title: '咒术回战',
    author: '芥见下下',
    category: 'riman',
    subCategory: 'shaonian',
    tags: ['日漫', '少年热血', '黑暗'],
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20teenage%20boy%20with%20pink%20hair%2C%20martial%20arts%20pose%2C%20dark%20supernatural%20energy%20surrounding%20him%2C%20clean%20minimal%20background%2C%20anime%20art%20style%2C%20high%20contrast%20dark%20and%20vibrant%20coral%20tones&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    description: '高中生虎杖悠仁拥有超常的体能。某天为解救受咒物「两面宿傩的手指」袭击的学长姐，他吞下咒物，让咒灵「两面宿傩」与自己合为一体。被咒术界最强咒术师五条悟发现后，虎杖加入了东京都立咒术高等专门学校。',
    chapters: 271,
    status: '已完结',
    rating: 9.2,
    views: 14300000,
    updateTime: '2024-12-28',
    featured: true,
    latestChapter: '第271话 自此以后',
  },
];

export const faqList = [
  {
    question: '樱花漫画是完全免费的吗？',
    answer: '是的，樱花漫画所有漫画资源均免费提供阅读和下载。我们致力于为漫画爱好者打造一个免费、完整的漫画阅读平台，无需任何付费即可畅享全集内容。',
  },
  {
    question: '如何在樱花漫画下载漫画进行离线阅读？',
    answer: '在漫画详情页，点击「下载」按钮即可将漫画章节保存到本地。下载完成后，您可以在「我的下载」中查看所有已下载的漫画，无需网络也能随时阅读。',
  },
  {
    question: '樱花漫画支持哪些类型的漫画？',
    answer: '樱花漫画收录了日漫、韩漫、国漫三大主流漫画类型，涵盖少年热血、少女恋爱、玄幻修仙、都市日常、悬疑推理、搞笑日常、科幻未来、冒险格斗等多个分类，满足不同读者的喜好。',
  },
  {
    question: '漫画更新频率怎么样？',
    answer: '我们与多家漫画平台保持同步更新，热门连载漫画通常在原版更新后24小时内就会在樱花漫画上线。您可以收藏喜欢的漫画，更新时我们会第一时间通知您。',
  },
  {
    question: '收藏和追更功能怎么使用？',
    answer: '点击漫画封面右下角的心形图标即可收藏该漫画。收藏后，您可以在「我的收藏」中查看所有收藏的漫画，当漫画有新章节更新时，系统会自动提醒您追更。',
  },
  {
    question: '樱花漫画的画质怎么样？',
    answer: '我们提供高清画质的漫画阅读体验，所有漫画均经过专业图片优化处理，确保在手机和电脑上都能获得清晰的阅读效果。部分热门漫画还支持超清画质模式。',
  },
];

export const statsData = [
  { value: '20,000+', label: '漫画资源' },
  { value: '500万+', label: '活跃读者' },
  { value: '99.9%', label: '服务可用率' },
  { value: '24h', label: '最快更新速度' },
];